//package imports
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import osanLogo from "../../assests/images/osan_logo.webp"
import { ClientPanelItems, AdminPanelItems } from "../../utils/constants/SideBarConstants";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faHeadset } from "@fortawesome/free-solid-svg-icons";



const Sidemenu = (props) => {
    const [subItemCollapse, setSubItemCollapse] = useState(false)
    const [iconIndex, setIconIndex] = useState("")
    const [subItemIndex, setSubItemIndex] = useState("")
    const history = useHistory();
    const items = props?.path === "/customerPortal" ? ClientPanelItems : AdminPanelItems
    const pathChange = history.location.pathname 
    let pathArray = pathChange.split("/")
    let pathOnChange = `${pathArray[2]}`
    let subPath = `${pathArray[3]}`

    

    useEffect(() => {
        if (subPath === "buyShares" || subPath === "sellShares") {
          setSubItemCollapse(true)
        } else if(pathOnChange !== "myShares" || pathOnChange === "profile") {
            setSubItemCollapse(false)
            setIconIndex("")
        }
      }, [subPath, pathOnChange]);


    const handleSidebarHover = (item, index) => {
          setIconIndex(index)
        setSubItemIndex("")
        if (item.label != "Shares") {
            setSubItemCollapse(false)
        }
    }
    //function to handle sub item
    const handleSubitemIndex = (item, subIndex) => {
        setSubItemIndex(subIndex)

    }



    return (
        <div className={props.collapse ? "container-fluid p-0 shadow col-md-1 " : "container-fluid p-0 shadow col-md-2 "}>
            <div className="row">
                <div className="d-flex flex-column  align-items-center min-vh-100">
                    <div className="sideBarLogoContainer d-flex justify-content-center align-items-center" >
                        <a className="text-decoration-none text-black  align-items-center"><span className="p-20">
                            <img src={osanLogo} alt="osanLogo" />
                        </span></a>
                    </div>
                    {items.map((item, index) => {
                        let hrefArray = item?.href.split("/") 
                        let subhrefArray = item
                        return (
                            <>
                                <div className={hrefArray[2] === pathOnChange ? "my-1 w-100 navStyle text-center" : "my-1 w-100 hoverBackground text-center"} key={index} onClick={() => handleSidebarHover(item, index)} >
                                    <Link to={item.href} className="d-flex flex-column justify-content-center text-decoration-none text-black align-items-center ">
                                        <div className="d-flex justify-content-around align-items-center textBackground w-100 p-2  ms-4 ">
                                            <div className="align-self-center w-25 ">
                                                <FontAwesomeIcon icon={ item?.icon} style={hrefArray[2] === pathOnChange ? {fontSize: "25px",color:"white"}: {fontSize: "25px"}} />
                                            </div>
                                            <div className={props.collapse ? "d-none" : "d-flex w-100 flex-row justify-content-center align-items-center  mx-2"}>
                                                <h6 className={hrefArray[2] === pathOnChange ? "fw-normal m-0 w-100 fs-xl-1 text-start text-white roboto" : "fw-normal m-0 w-100 fs-xl-1 text-start roboto"}>{item.label}</h6>
                                                {
                                                    item?.subItems != undefined ?
                                                        <>
                                                            <i className={subItemCollapse ? iconIndex === index  ? `bi bi-chevron-up  text-white` : `bi bi-chevron-up text-white ` : iconIndex === index || pathOnChange === "myShares"? `bi bi-chevron-down text-white ` : `bi bi-chevron-down `} onClick={() => setSubItemCollapse(!subItemCollapse)}  ></i>
                                                        </>
                                                        :
                                                        null
                                                }
                                            </div>

                                            <div className={props.collapse ? "d-block" : "d-none"}>
                                                {
                                                    item?.subItems ?
                                                        <>
                                                            <i className={subItemCollapse ? iconIndex === index  ? `bi bi-chevron-up  text-white` : `bi bi-chevron-up text-white` : iconIndex === index  || pathOnChange === "myShares"  ? `bi bi-chevron-down text-white ` : `bi bi-chevron-down `} onClick={() => setSubItemCollapse(!subItemCollapse)}  ></i>
                                                        </>
                                                        :
                                                        null
                                                }
                                            </div>

                                        </div>
                                    </Link>
                                </div>
                                    {
                                        item?.subItems?.map((data,itemIndex) => {
                                            let hrefArray = data?.href.split("/")
                                            return (
                                                <div key={itemIndex} className={subItemCollapse  ? "d-flex justify-content-center d-block w-100 hoverBackground my-1" : "d-none"} onClick={() => handleSubitemIndex(data,itemIndex)}>
                                                <div className="w-100 text-center">
                                                    <Link to={data.href} className="text-decoration-none">
                                                        <div className={subItemIndex === itemIndex || hrefArray[3] === subPath ? "subMenuChange py-2" : "subMenuHover py-2"}>
                                                            <FontAwesomeIcon icon={ data?.icon} style={{fontSize: "18px", color: "black"}} />
                                                            <h6 className={props.collapse ? "d-none" : "m-0 p-2 fw-normal text-black Roboto"}>
                                                                {data?.label}
                                                            </h6>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </>
                        )
                    })
                    }
                </div>
            </div>
        </div>
    )
}

export default Sidemenu